var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconPet = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 40 40",
  style: {
    enableBackground: "new 0 0 40 40"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.9,17.6c-1.1-2.7-4.2-4-6.8-2.9c-2.6,1.1-3.8,4.2-2.7,6.9c1.1,2.7,4.2,4,6.8,2.9 C10.9,23.4,12.1,20.3,10.9,17.6z M25.6,15.4c3,0.3,5.7-2.3,6-5.8C32,6.1,29.8,3,26.8,2.8c-3-0.3-5.7,2.3-6,5.8 C20.5,12.1,22.6,15.2,25.6,15.4z M14.4,15.4c3-0.3,5.1-3.4,4.8-6.9s-3-6.1-6-5.8C10.2,3,8,6.1,8.4,9.6C8.7,13.1,11.4,15.7,14.4,15.4 z M35.9,14.7c-2.6-1.1-5.7,0.2-6.8,2.9c-1.1,2.7,0.1,5.8,2.7,6.9s5.7-0.2,6.8-2.9C39.7,18.9,38.5,15.8,35.9,14.7z M31,29.8L31,29.8 c-1.4-4.2-4.1-7.8-7.5-10.5l0,0c-0.3-0.3-0.6-0.5-1-0.7c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.3-0.1c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.3-0.1 c0,0,0,0,0,0c-0.2-0.1-0.4-0.1-0.6-0.2c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.2-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0 c-0.1,0-0.2,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0 c-0.1,0-0.2,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0.1c0,0,0,0-0.1,0 c-0.2,0.1-0.4,0.1-0.6,0.2c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.1c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.1c0,0,0,0,0,0 c-0.4,0.2-0.7,0.4-1,0.7l0,0C13,22,10.4,25.7,9,29.8l0,0c-0.1,0.4-0.2,0.8-0.3,1.3C8.3,34,10,36.4,12.6,37c0.6,0.1,1.1,0.2,1.8,0.2 c1.8,0,3.5-0.7,4.7-1.7c0,0,0.3-0.3,0.9-0.3c0.6,0,1,0.3,1,0.3c1.3,1.1,2.9,1.7,4.7,1.7c0.6,0,1.2-0.1,1.8-0.2 c2.6-0.6,4.3-3,3.9-5.9C31.3,30.7,31.2,30.3,31,29.8z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_pet.dfd7d2bb.svg";
export { ForwardRef as ReactComponent };